import { useMutation } from '@tanstack/react-query';

import { LotoOrderSearchRequest } from 'api/searchRequest/LotoOrderSearchRequest';
import { AcceptUserInfo } from 'model/AcceptUserInfo';
import { YN_TYPE } from 'types/enumType';

import client from './client';
import { BaseResp, LotoActionLogListResp, LotoCommunicationListResp, LotoConclusionListResp } from './response';
import { LockerSearchRequest } from './searchRequest/LockerSearchRequest';
import { LotoCommunicationSearchRequest } from './searchRequest/LotoCommunicationSearchRequest';
import { LotoTransferSearchRequest } from './searchRequest/LotoTransferSearchRequest';

export const getLotoConclusionList = (
  req: LotoOrderSearchRequest | LotoTransferSearchRequest,
): Promise<LotoConclusionListResp> =>
  client.get('v1/loto/locks', { params: req });
export const getLotoCommunicationList = (
  req: LotoCommunicationSearchRequest,
): Promise<LotoCommunicationListResp> =>
  client.get('v1/history/list', { params: req });

export const getLotoActionLogList = (req: LockerSearchRequest): Promise<LotoActionLogListResp> => client.get('v1/loto/actions', { params: req })

// export const downloadConclusionListExcel = (req: SearchRequest): Promise<void> => downloadExcel(req, 'v1/conclusion/excel');

const oldLotoSettingYn = (req: OldLotoSettingYnRequest): Promise<BaseResp> => client.post(`v1/loto/old/${req.orderId}`, { ...req });
export const useOldLotoSettingYn = () => useMutation(oldLotoSettingYn);

export interface OldLotoSettingYnRequest extends AcceptUserInfo {
  orderId: number;
  oldLotoYn: YN_TYPE;
}